module.exports = __webpack_public_path__ + "img/payconiq-logo.8ef1f5e2.png";